import { render, staticRenderFns } from "./VideoOpen.vue?vue&type=template&id=3b7a60c3&scoped=true&"
import script from "./VideoOpen.vue?vue&type=script&lang=js&"
export * from "./VideoOpen.vue?vue&type=script&lang=js&"
import style0 from "./VideoOpen.vue?vue&type=style&index=0&id=3b7a60c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a60c3",
  null
  
)

export default component.exports